import eventMixin from '../lib/mixins/event';
import Logger from '../lib/logger';

export default class SectionMarquee {

    constructor(dom) {

        // Vars
        // ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
        this.NAME = `SectionMarquee`;

        this.isScrolling = false;

        this.dom = dom;
        this.domActiveClass = `section-marquee--active`;
        this.scrollerDom = this.dom.querySelector(`[data-section-marquee-scroller]`);
        this.textDoms = this.dom.querySelectorAll(`[data-section-marquee-text]`);

        this.resizeTimeout;
        this.scrollInterval;
        this.scrollSpeed = this.dom.getAttribute(`data-section-marquee-scroller-speed`) || 8000;
        this.scrollDistance = 0;

    }

    // Logic
    // ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
    init() {
        Logger.info(`${this.NAME} > init`);

        const self = this;

        // Measure the doms
        setTimeout(() => {
            this.measureTextDoms();
            window.addEventListener('resize', (e) => {
                self.hide();
                clearTimeout(this.resizeTimeout);
                this.resizeTimeout = setTimeout(() => {
                    self.measureTextDoms();
                    self.start();
                    setTimeout(self.show.bind(self), 2000);
                }, 500);
            });
        }, 1000);

        /**
        * Initialize the marquee when visible
        */
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const intersecting = entry.isIntersecting;

                if (intersecting && !this.isScrolling) {
                    setTimeout(() => {
                        self.start();
                    }, 1000);
                } else if (!intersecting && this.isScrolling) {
                    self.stopScrolling();
                }
            })
        })

        observer.observe(this.dom);
    }

    hide() {
        Logger.info(`${this.NAME} > hide`);
        this.dom.classList.remove(this.domActiveClass);
    }

    /**
     * Measure the width of the first text dom
     */
    measureTextDoms() {
        Logger.info(`${this.NAME} > measureTextDoms`);

        if (!this.textDoms[0]) {
            return;
        }

        // Measure the width of the text dom
        const textDomWidth = this.textDoms[0].offsetWidth;
        if (textDomWidth < 1) {
            return;
        }

        // Measure the width of the parent
        const parentWidth = this.dom.offsetWidth;

        // Get the minimum number of text doms to fill the parent
        const minimumTextDoms = Math.ceil(parentWidth / textDomWidth) * 2;

        // Remove all text doms accept for the first
        this.textDoms.forEach((dom, i) => {
            if (i === 0) return;
            dom.remove();
        });

        // Append
        for (let i = 0; i < minimumTextDoms; i++) {
            this.scrollerDom.append(this.textDoms[0].cloneNode(true));
        }

        this.scrollDistance = (minimumTextDoms * textDomWidth) / 2;

        this.reset();
    }

    /**
     * Reset
     */
    reset() {
        Logger.info(`${this.NAME} > reset`);

        // Reset
        this.scrollerDom.style.transition = `none`;
        this.scrollerDom.style.transform = `translateX(0px)`;
    }

    /**
     * Show the marquee
     */
    show() {
        Logger.info(`${this.NAME} > show`);
        this.dom.classList.add(this.domActiveClass);
    }

    /**
     * Scroll the scroll dom
     */
    scroll() {
        Logger.info(`${this.NAME} > scroll`);

        this.reset();

        // Scroll
        setTimeout(() => {
            this.scrollerDom.style.transition = `${this.scrollSpeed / 1000}s transform linear`;
            this.scrollerDom.style.transform = `translateX(-${this.scrollDistance}px)`;
            this.show();
            this.isScrolling = true;
        }, 20);
    }

    start() {
        Logger.info(`${this.NAME} > start`);
        clearInterval(this.scrollInterval);
        this.scroll();
        this.scrollInterval = setInterval(this.scroll.bind(this), this.scrollSpeed);
    }

    /**
     * Stop all scrolling
     */
    stopScrolling() {
        Logger.info(`${this.NAME} > stopScrolling`);
        clearInterval(this.scrollInterval);
        this.hide();
        this.reset();
        this.isScrolling = false;
    }

}

// Mixins
Object.assign(SectionMarquee.prototype, eventMixin);
